(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyServiceCategoryDialogV2Controller', CompanyServiceCategoryDialogV2Controller);

    CompanyServiceCategoryDialogV2Controller.$inject = ['$rootScope', '$timeout', '$scope', '$stateParams', 'entity', 'ServiceCategory', 'SettingInfo', 'Company', 'Servant', 'AlbumInfo', 'ServiceCategoryCustom', '$state'];

    function CompanyServiceCategoryDialogV2Controller($rootScope, $timeout, $scope, $stateParams, entity, ServiceCategory, SettingInfo, Company, Servant, AlbumInfo, ServiceCategoryCustom, $state) {
        var vm = this;
        vm.scope = $scope;
        vm.serviceCategory = entity;
        vm.clear = clear;
        vm.save = save;

        vm.okModal = okModal;
        vm.closeModal = closeModal;
        vm.getModalTitle = getModalTitle;


        $rootScope.$broadcast('hideNavBar');
        ServiceCategoryCustom.getServiceCategoriesByCurrentCompany().query().$promise.then(function (result) {

            if (vm.serviceCategory != null && vm.serviceCategory.id != null && result != null) {
                vm.servicecategories = result.filter(function (v) {

                        return (v.id != vm.serviceCategory.id && v.categoryName != "DEFAULT_CATEGORY")
                    }
                );
            } else {
                vm.servicecategories = result;
            }

        });


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
        }

        function save() {
            if (vm.scope.editForm.$valid) {
                vm.isSaving = true;
                if (vm.serviceCategory.id !== null) {
                    ServiceCategory.update(vm.serviceCategory, onSaveSuccess, onSaveError);
                } else {
                    ServiceCategory.save(vm.serviceCategory, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:serviceCategoryUpdate', result);
            // $uibModalInstance.close(result);
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.companyServiceCategoryList', {id: result.id});
            // vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function okModal() {
            save();

        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.companyServiceCategoryList');

        }

        function getModalTitle() {
            if (!vm.serviceCategory.id)
                return 'tikonApp.serviceCategory.home.createLabel';
            else
                return 'tikonApp.serviceCategory.home.viewOrEditLabel';
        }

    }
})();
